// src/pages/SepticSystems.js

import React from 'react';
import Hero from '../../components/Hero';
import { fetchPageContent } from '../../utils/api';
import useFetch from '../../hooks/useFetch';
import { Helmet } from 'react-helmet-async';
import InteriorHeroSkeleton from '../../components/InteriorHeroSkeleton';
import Footer from '../../components/Footer';
import FooterHero from '../../components/FooterHero';
import Testimonials from '../../components/Testimonials';
import Breadcrumbs from '../../components/Breadcrumbs';
import ProjectsSlider from '../../components/ProjectsSlider';
import Sidebar from '../../components/Sidebar';
import FaqComponent from '../../components/FaqComponent';

const SepticSystems = () => {
  const { data: heroContent, data: interiorPageContent, loading } = useFetch(() => fetchPageContent('septic-systems'), 'septic-systems');
  const faqs = [
    {
      question: "How often should my septic system be pumped?",
      answer: "Septic tanks typically need to be pumped every 3-5 years, depending on the tank size and the number of people using the system."
    },
    {
      question: "What are the signs of a failing septic system?",
      answer: "Common signs include slow drains, sewage backups, foul odors near the tank or drain field, and overly lush or green patches of grass in the drain field area."
    },
    {
      question: "What types of septic systems do you install?",
      answer: "We install conventional systems, chamber systems, mound systems, and Eljen Systems. Our team will help you choose the best option for your property."
    },
    {
      question: "Do I need a permit to install a septic system?",
      answer: "Yes, installing a septic system requires permits to ensure compliance with local codes by the home owner."
    },
    {
      question: "What does the septic system installation process involve?",
      answer: "Our process includes a site evaluation, customized system design, excavation and installation, and a final inspection to ensure everything meets regulations."
    },
    {
      question: "How can I maintain my septic system?",
      answer: "Regular pumping, avoiding flushing harmful substances, and scheduling routine inspections are key to maintaining a healthy septic system."
    },
    {
      question: "What should I do if my septic system is malfunctioning?",
      answer: "Contact us immediately. Our team can assess the issue and provide repairs or recommendations for a replacement if necessary."
    },
    {
      question: "Are septic systems environmentally friendly?",
      answer: "Yes, when properly installed and maintained, septic systems safely treat and dispose of wastewater, protecting groundwater and the environment."
    },
    {
      question: "How long does a septic system last?",
      answer: "With proper maintenance, most septic systems can last 15-25 years or longer, depending on the system type and usage."
    },
    {
      question: "Can Lizotte Construction inspect my current septic system?",
      answer: "We currently do not offer septic system inspections at the moment, however, we can put you in contact with the right companies to inspect your septic system."
    }
  ];

  return (
    <div>
      {loading ? (
        // Render HeroSkeleton component when loading
        <InteriorHeroSkeleton />
      ) : (
        (
          <>
            <Helmet>
              <title>Septic Systems Services</title>
              <meta name="description" content="Lizotte Construction specializes in the installation, maintenance, and repair /of all types of septic systems, ensuring that your property is equipped with a reliable and environmentally safe wastewater treatment solution." />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <link rel="canonical" href="http://yourwebsite.com/home" />

              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
              <link href="https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous"></link>
              <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossorigin="anonymous"></script>
            </Helmet>
            {loading ? (
              <p>Loading...</p>
            ) : (
              heroContent && <Hero className="interior-hero" content={heroContent.hero} featuredMedia={heroContent.featuredMedia} />
            )}
            {/* Other WhoWeAre Page Content */}
            {interiorPageContent?.interiorPageContent && (
              <div className='container'>
                <div className="main-page-content row justify-content-center align-items-stretch panel">
                  <div className='col-12'>
                    <Breadcrumbs />
                    <div className='page-card'>
                      <div className='row align-items-stretch row-sidebar-page'>
                        <Sidebar />
                        <div className='col-9 col-sidebar-page'>
                          <div className='page-content' dangerouslySetInnerHTML={{ __html: interiorPageContent.interiorPageContent }} />
                          <FaqComponent faqs={faqs} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )
      )}
      <ProjectsSlider />
      <Testimonials />
      <FooterHero />
      <Footer />
    </div>
  );
};

export default SepticSystems;
